import(/* webpackMode: "eager" */ "/app/app/(students)/students/classmates/page.tsx");
